import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .TransferDetailsPage__buttons-inner {
    button {
      padding: 7px 10px;
      margin: 0 30px 20px 0;
      @include respond-to(sm) {
        margin: 0 15px 20px 0;
      }
    }
  }
`;

export { staticStyles };
